// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"lo-z","slideIn":"mo-z"};